// Centralized site configuration & constants for A Girl's Girl
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Donations are handled securely via AutoBooks (no on-site payment processing)
export const AUTOBOOKS_URL = "https://app.autobooks.co/pay/a-girls-girl";

// Merchandise is fulfilled by our Printify store
export const PRINTIFY_URL = "https://shes-a-girls-girl.printify.me/";

export const DONATE_TAGLINE =
  "Every gift helps equip girls with confidence, leadership, and life readiness.";

export const ORG_EMAIL = "info@shesagirlsgirl.org";

// Featured products (mirrors live Printify catalog — swap to CMS-managed later)
export const FEATURED_PRODUCTS = [
  {
    id: "agg-ceramic-mug",
    name: "AGG Signature Ceramic Mug",
    category: "Mugs",
    price: "$13.99",
    description:
      "Start every morning with a reminder of her worth. Our 11oz ceramic mug carries the AGG message of confidence, leadership, and sisterhood.",
    image:
      "https://images-api.printify.com/mockup/6864a41d28ceaed3c70345e5/65216/10411/ceramic-mug-11oz.jpg?camera_label=context-2&revision=1752549258072",
    url: "https://shes-a-girls-girl.printify.me/product/21657543",
  },
];

// Future merchandise categories — page is designed to grow into a full catalog
export const SHOP_CATEGORIES = [
  "Apparel",
  "T-Shirts",
  "Hoodies",
  "Crewnecks",
  "Journals",
  "Mugs",
  "Tote Bags",
  "Water Bottles",
  "Hats",
  "Stickers",
  "Bracelets",
  "Accessories",
  "Event Merchandise",
  "Limited Edition Collections",
  "Holiday Collections",
  "Fundraiser Merchandise",
];
